<template>
  <PasswordField
    name="password"
    :label="translate(`${LOCALE_PREFIX}.form.fields.password`)"
    :placeholder="translate(`${LOCALE_PREFIX}.form.fields.password`)"
    toggleMask
    v-bind="{
      inputProps: { 'data-testid': 'passwordField' },
    }"
  />
</template>

<script setup lang="ts">
import { LoginLocalePrefix } from '../../../enums';
import { useTranslation } from '@centric-os/helpers';

const { translate } = useTranslation();
const LOCALE_PREFIX = LoginLocalePrefix.LOGIN;
</script>
